// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  padding-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

header img.logo {
  max-height: 48px;
  width: 110px;
  max-width: 110px;
  margin-left: 10px;
}

header input.search {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: none;
  border-radius: 8px;
  outline: none;
  padding: 8px 8px 8px 45px;
}

.drop {
  position: relative;
  display: inline-block;
  vertical-align: top;
  overflow: visible;
  max-width: 1040px;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border: 1px solid #f8f8f8;
  border-radius: 8px;
  margin-right: 15px;
  outline: none;
}

.dropdown-content {
  display: none;
  list-style-type: none;
  background: #ffffff;
  border: 1px solid #f8f8f8;
  box-shadow: 0 4px 22px rgb(171 171 171 / 25%);
  padding: 8px 0;
  margin: 0;
  position: absolute;
  z-index: 99;
  width: 100%;
  max-height: 240px;
  min-height: 70px;
  overflow-y: auto;
  border-radius: 0.25rem;
  top: 38px;
  left: 0px;
}

.dropdown-content::-webkit-scrollbar {
  display: none;
}

.dropdown-content li {
  padding: 4px 16px;
  display: block;
  margin: 0;
  color: #0f062b;
  /* cursor: pointer; */
}

/* .dropdown-content .search-op {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  margin-bottom: 1rem;
} */
.dropdown-content .search-op {
  display: flex;
  justify-content: space-between;
  padding: 4px 14px 0 14px;
  margin-bottom: 1rem;
  flex-direction: column;
  gap: 7px;
}

.dropdown-content .search-op span,
.dropdown-content .search-op button {
  cursor: pointer;
  padding: 7px;
}

.dropdown-content .search-op span:hover {
  background: #efefef;
  border-radius: 6px;
}

.activeOption {
  background: #efefef;
  border-radius: 6px;
}

.dropdown-content .search-op.active {
  background: #E1E1F9;
}

.dropdown-content .search-op button {
  margin-left: auto;
  background: transparent;
  color: #6c2fbb;
  border: none;
  padding: 0 0.25rem;
}

#myInput {
  /* background-image: url("../../../assets/images/search.png");
  background-position: 14px 16px;
  background-size: 16px;
  background-repeat: no-repeat; */
  font-size: 16px;
}

.head-type {
  color: #000;
  background: #ccc;
}

header .three-btn {
  display: flex;
  align-items: center;
  gap: 10px;
}

header .three-btn button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #f8f8f8;
  border-radius: 8px;
}

header .dropdown.noti-dropdown .dropdown-menu {
  background: #ffffff;
  border: 1px solid #f8f8f8;
  box-shadow: 0 4px 22px rgb(171 171 171 / 25%);
  min-width: 20rem;
  padding: 0;
  top: 0 !important;
  right: 0;
  /*transform: translateX(-50%) !important;*/
  /*left: 50% !important;*/

}

header .dropdown.noti-dropdown .dropdown-menu ul {
  max-height: 200px;
  overflow-y: auto;
  padding-left: 0;
  margin-bottom: 0;
  scrollbar-width: none;
}

.dropdown-item {
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  display: block;
}

header .dropdown.noti-dropdown .dropdown-menu ul::-webkit-scrollbar {
  display: none;
}

header .dropdown.noti-dropdown .dropdown-menu .view-area {
  border-top: 1px solid #8080804d;
}

header .dropdown.noti-dropdown .dropdown-menu .view-area button {
  color: #6c2fbb;
  display: inline;
  padding: 0 15px;
}

header .dropdown.noti-dropdown .dropdown-menu .dropdown-item,
header .dropdown.noti-dropdown .dropdown-menu .dropdown-item:active,
header .dropdown.noti-dropdown .dropdown-menu .dropdown-item.active {
  color: #0f062b;
  background: transparent;
}

header .dropdown.noti-dropdown .dropdown-menu ul li {
  padding: 5px 0;
}

header .dropdown.noti-dropdown .new-dropdown-menu {
  transform: translate3d(0, 0, 0) !important;
  left: auto !important;
  top: 48px !important;
}

/* header .dropdown.noti-dropdown .dropdown-menu ul li:not(:last-child) {
  border-bottom: 1px solid #80808029;
} */

/*header .dropdown.noti-dropdown .dropdown-menu.show {
  /*transform: translate3d(114px, 50px, 0px) !important;*/
/*}*/

header .three-btn button.notification {
  position: relative;
}

header .three-btn button.notification::after {
  position: absolute;
  top: 7px;
  right: 7px;
  content: "";
  /*width: 7px;*/
  /*height: 7px;*/
  background: #dc3545;
  border-radius: 50%;
  border: 0;
  margin: 0;
}

header .three-btn button.create-video {
  /*background: #7a2df9;*/
  background: #6c2fbb;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  padding: 14px 32px;
  gap: 10px;
  width: 100%;
  white-space: nowrap;
  /*min-width: 240px;*/
}

.notification-counter {
  position: absolute;
  background-color: red;
  color: white;
  padding: 0;
  border-radius: 50%;
  font-size: 11px;
  width: 15px;
  height: 15px;
  text-align: center;
  /*WC 06212022*/
  /*top: 12px;
  right: 6px;*/
  top: 6px;
  right: 3px;
  /*WC 06212022*/
}

.img-title .profile {
  border-radius: 8px;
  width: 45px;
  height: 45px;
}

/*.profile-image {
  width: 45px;
  height: 45px;
  text-align: center;
  color: #fff;
  background: #6c2fbb;
  border-radius: 8px;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  vertical-align: middle;
  text-transform: uppercase;*/
/*line-height: 2;*/
/*}*/

header .three-btn .sign-button {
  /*background: #7a2df9;*/
  text-align: center;
  background: #6c2fbb;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  padding: 12px 32px;
  gap: 10px;
  width: 100%;
  white-space: nowrap;
}

input:-webkit-autofill {
  -webkit-background-clip: text;
  -webkit-text-fill-color: #000000;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  box-shadow: inset 0 0 20px 20px #ffffff;
}

.fa-times-circle {
  color: #515151;
  font-size: 19px;
  font-weight: 500;
}

.voice-icon {
  color: #A261F5;
  font-size: 22px;
  cursor: pointer;
}

.recording-mic {
  width: 150px;
  height: 150px;
  background-color: rgba(108, 47, 187, 0.1);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto;
  position: relative;
  z-index: 1;
}

.recording-mic::after {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(108, 47, 187, 0.1);
  border-radius: 100%;
  z-index: -1;
  transform: scale(0);
  animation: wave-animation 1.1s infinite;
}

.voice-status-text {
  font-size: 20px;
  color: #ce6060;
  font-weight: 400;
}

@keyframes wave-animation {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1.4);
  }

  75% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

.recording-mic i {
  font-size: 50px;
  color: #6c2fbb;
}

@media (max-width: 991px) {
  .notification-counter {
    margin: 0 auto;
    top: 7px;
    right: 0;
    left: 15px;
  }

  header .three-btn button.create-video {
    padding: 14px 16px;
    width: -moz-fit-content;
    width: fit-content;
  }

  header {
    flex-wrap: wrap;
  }

  .drop {
    order: 2;
    /*margin-top: 15px;*/
    margin-right: 0;
  }

  header .three-btn {
    margin-left: auto;
    width: 100%;
    margin-top: 10px;
    justify-content: flex-end;
  }

  header .three-btn .menu {
    margin-right: auto;
  }

  header .dropdown.noti-dropdown .dropdown-menu.show {
    min-width: 100px;
  }

  header .dropdown.noti-dropdown .dropdown-menu .view-area button {
    font-size: 14px;
  }
}

@media (max-width: 675px) {
  header .dropdown.noti-dropdown .dropdown-menu.show {
    max-width: 280px;
  }

  header .three-btn button.create-video span {
    display: none;
  }

  header .three-btn button.create-video {
    min-width: 48px;
    height: 48px;
    padding: 0;
  }

  header .three-btn button.create-video svg {
    width: 18px;
    height: 18px;
  }
}

@media (max-width: 425px) {
  #myInput {
    background-position: 14px 11px;
    background-size: 15px;
  }

  header .three-btn button.create-video,
  header .three-btn button {
    min-width: 40px;
    height: 40px;
    margin: 0;
  }

  .profile-image-pic {
    width: 40px;
    height: 40px;
  }

  header .three-btn button svg {
    width: 15px;
    height: 15px;
  }

  header .three-btn {
    gap: 5px;
  }

  .drop {
    height: 40px;
  }

  header .dropdown.noti-dropdown .dropdown-menu .dropdown-item {
    padding: 0.15rem 1rem;
  }

  header .dropdown.noti-dropdown .dropdown-menu.show {
    max-width: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layout/new-header/new-header.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;GAMG;AACH;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;;;iCAG+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,QAAQ;EACR,0CAA0C;EAC1C,wBAAwB;;AAE1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;yDACyD;AACzD,IAAI;;AAEJ;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd;cACY;EACZ,QAAQ;EACR,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;6BAW6B;AAC7B,kBAAkB;AAClB,IAAI;;AAEJ;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yDAAiD;EAAjD,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,QAAQ;IACR,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;;IAEE,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["header {\n  padding-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\nheader img.logo {\n  max-height: 48px;\n  width: 110px;\n  max-width: 110px;\n  margin-left: 10px;\n}\n\nheader input.search {\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  border: none;\n  border-radius: 8px;\n  outline: none;\n  padding: 8px 8px 8px 45px;\n}\n\n.drop {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  overflow: visible;\n  max-width: 1040px;\n  width: 100%;\n  height: 48px;\n  background: #ffffff;\n  border: 1px solid #f8f8f8;\n  border-radius: 8px;\n  margin-right: 15px;\n  outline: none;\n}\n\n.dropdown-content {\n  display: none;\n  list-style-type: none;\n  background: #ffffff;\n  border: 1px solid #f8f8f8;\n  box-shadow: 0 4px 22px rgb(171 171 171 / 25%);\n  padding: 8px 0;\n  margin: 0;\n  position: absolute;\n  z-index: 99;\n  width: 100%;\n  max-height: 240px;\n  min-height: 70px;\n  overflow-y: auto;\n  border-radius: 0.25rem;\n  top: 38px;\n  left: 0px;\n}\n\n.dropdown-content::-webkit-scrollbar {\n  display: none;\n}\n\n.dropdown-content li {\n  padding: 4px 16px;\n  display: block;\n  margin: 0;\n  color: #0f062b;\n  /* cursor: pointer; */\n}\n\n/* .dropdown-content .search-op {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 16px;\n  margin-bottom: 1rem;\n} */\n.dropdown-content .search-op {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 14px 0 14px;\n  margin-bottom: 1rem;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.dropdown-content .search-op span,\n.dropdown-content .search-op button {\n  cursor: pointer;\n  padding: 7px;\n}\n\n.dropdown-content .search-op span:hover {\n  background: #efefef;\n  border-radius: 6px;\n}\n\n.activeOption {\n  background: #efefef;\n  border-radius: 6px;\n}\n\n.dropdown-content .search-op.active {\n  background: #E1E1F9;\n}\n\n.dropdown-content .search-op button {\n  margin-left: auto;\n  background: transparent;\n  color: #6c2fbb;\n  border: none;\n  padding: 0 0.25rem;\n}\n\n#myInput {\n  /* background-image: url(\"../../../assets/images/search.png\");\n  background-position: 14px 16px;\n  background-size: 16px;\n  background-repeat: no-repeat; */\n  font-size: 16px;\n}\n\n.head-type {\n  color: #000;\n  background: #ccc;\n}\n\nheader .three-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\nheader .three-btn button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  height: 48px;\n  background: #ffffff;\n  border: 1px solid #f8f8f8;\n  border-radius: 8px;\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu {\n  background: #ffffff;\n  border: 1px solid #f8f8f8;\n  box-shadow: 0 4px 22px rgb(171 171 171 / 25%);\n  min-width: 20rem;\n  padding: 0;\n  top: 0 !important;\n  right: 0;\n  /*transform: translateX(-50%) !important;*/\n  /*left: 50% !important;*/\n\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu ul {\n  max-height: 200px;\n  overflow-y: auto;\n  padding-left: 0;\n  margin-bottom: 0;\n  scrollbar-width: none;\n}\n\n.dropdown-item {\n  overflow: hidden !important;\n  white-space: nowrap !important;\n  text-overflow: ellipsis !important;\n  display: block;\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu ul::-webkit-scrollbar {\n  display: none;\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu .view-area {\n  border-top: 1px solid #8080804d;\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu .view-area button {\n  color: #6c2fbb;\n  display: inline;\n  padding: 0 15px;\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu .dropdown-item,\nheader .dropdown.noti-dropdown .dropdown-menu .dropdown-item:active,\nheader .dropdown.noti-dropdown .dropdown-menu .dropdown-item.active {\n  color: #0f062b;\n  background: transparent;\n}\n\nheader .dropdown.noti-dropdown .dropdown-menu ul li {\n  padding: 5px 0;\n}\n\nheader .dropdown.noti-dropdown .new-dropdown-menu {\n  transform: translate3d(0, 0, 0) !important;\n  left: auto !important;\n  top: 48px !important;\n}\n\n/* header .dropdown.noti-dropdown .dropdown-menu ul li:not(:last-child) {\n  border-bottom: 1px solid #80808029;\n} */\n\n/*header .dropdown.noti-dropdown .dropdown-menu.show {\n  /*transform: translate3d(114px, 50px, 0px) !important;*/\n/*}*/\n\nheader .three-btn button.notification {\n  position: relative;\n}\n\nheader .three-btn button.notification::after {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  content: \"\";\n  /*width: 7px;*/\n  /*height: 7px;*/\n  background: #dc3545;\n  border-radius: 50%;\n  border: 0;\n  margin: 0;\n}\n\nheader .three-btn button.create-video {\n  /*background: #7a2df9;*/\n  background: #6c2fbb;\n  font-weight: 400;\n  font-size: 16px;\n  color: #ffffff;\n  padding: 14px 32px;\n  gap: 10px;\n  width: 100%;\n  white-space: nowrap;\n  /*min-width: 240px;*/\n}\n\n.notification-counter {\n  position: absolute;\n  background-color: red;\n  color: white;\n  padding: 0;\n  border-radius: 50%;\n  font-size: 11px;\n  width: 15px;\n  height: 15px;\n  text-align: center;\n  /*WC 06212022*/\n  /*top: 12px;\n  right: 6px;*/\n  top: 6px;\n  right: 3px;\n  /*WC 06212022*/\n}\n\n.img-title .profile {\n  border-radius: 8px;\n  width: 45px;\n  height: 45px;\n}\n\n/*.profile-image {\n  width: 45px;\n  height: 45px;\n  text-align: center;\n  color: #fff;\n  background: #6c2fbb;\n  border-radius: 8px;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 600;\n  vertical-align: middle;\n  text-transform: uppercase;*/\n/*line-height: 2;*/\n/*}*/\n\nheader .three-btn .sign-button {\n  /*background: #7a2df9;*/\n  text-align: center;\n  background: #6c2fbb;\n  font-weight: 600;\n  font-size: 16px;\n  color: #ffffff;\n  padding: 12px 32px;\n  gap: 10px;\n  width: 100%;\n  white-space: nowrap;\n}\n\ninput:-webkit-autofill {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: #000000;\n  transition: background-color 5000s ease-in-out 0s;\n  box-shadow: inset 0 0 20px 20px #ffffff;\n}\n\n.fa-times-circle {\n  color: #515151;\n  font-size: 19px;\n  font-weight: 500;\n}\n\n.voice-icon {\n  color: #A261F5;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.recording-mic {\n  width: 150px;\n  height: 150px;\n  background-color: rgba(108, 47, 187, 0.1);\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 30px auto;\n  position: relative;\n  z-index: 1;\n}\n\n.recording-mic::after {\n  content: '';\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(108, 47, 187, 0.1);\n  border-radius: 100%;\n  z-index: -1;\n  transform: scale(0);\n  animation: wave-animation 1.1s infinite;\n}\n\n.voice-status-text {\n  font-size: 20px;\n  color: #ce6060;\n  font-weight: 400;\n}\n\n@keyframes wave-animation {\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(1.2);\n  }\n\n  50% {\n    transform: scale(1.4);\n  }\n\n  75% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n.recording-mic i {\n  font-size: 50px;\n  color: #6c2fbb;\n}\n\n@media (max-width: 991px) {\n  .notification-counter {\n    margin: 0 auto;\n    top: 7px;\n    right: 0;\n    left: 15px;\n  }\n\n  header .three-btn button.create-video {\n    padding: 14px 16px;\n    width: fit-content;\n  }\n\n  header {\n    flex-wrap: wrap;\n  }\n\n  .drop {\n    order: 2;\n    /*margin-top: 15px;*/\n    margin-right: 0;\n  }\n\n  header .three-btn {\n    margin-left: auto;\n    width: 100%;\n    margin-top: 10px;\n    justify-content: flex-end;\n  }\n\n  header .three-btn .menu {\n    margin-right: auto;\n  }\n\n  header .dropdown.noti-dropdown .dropdown-menu.show {\n    min-width: 100px;\n  }\n\n  header .dropdown.noti-dropdown .dropdown-menu .view-area button {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 675px) {\n  header .dropdown.noti-dropdown .dropdown-menu.show {\n    max-width: 280px;\n  }\n\n  header .three-btn button.create-video span {\n    display: none;\n  }\n\n  header .three-btn button.create-video {\n    min-width: 48px;\n    height: 48px;\n    padding: 0;\n  }\n\n  header .three-btn button.create-video svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n@media (max-width: 425px) {\n  #myInput {\n    background-position: 14px 11px;\n    background-size: 15px;\n  }\n\n  header .three-btn button.create-video,\n  header .three-btn button {\n    min-width: 40px;\n    height: 40px;\n    margin: 0;\n  }\n\n  .profile-image-pic {\n    width: 40px;\n    height: 40px;\n  }\n\n  header .three-btn button svg {\n    width: 15px;\n    height: 15px;\n  }\n\n  header .three-btn {\n    gap: 5px;\n  }\n\n  .drop {\n    height: 40px;\n  }\n\n  header .dropdown.noti-dropdown .dropdown-menu .dropdown-item {\n    padding: 0.15rem 1rem;\n  }\n\n  header .dropdown.noti-dropdown .dropdown-menu.show {\n    max-width: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
